import { ArrowRight } from 'lucide-react'
import { Link, useRouteLoaderData } from 'react-router'
import { Logo } from '#app/components/logo.tsx'
import { Button } from '#app/components/ui/button.tsx'
import { type loader as rootLoader } from '#app/root.tsx'

export function Navbar() {
	const data = useRouteLoaderData<typeof rootLoader>('root')
	const isLoggedIn = Boolean(data?.user?.id)
	return (
		<header className="z-level-10 top-0 right-0 left-0">
			<div className="mr-3 ml-4 flex items-center justify-between py-4 md:mx-12">
				<div>
					<Link to="/" className="flex items-center gap-2">
						<Logo className="h-6 w-6" aria-hidden="true" />
						<span className="text-foreground hidden text-xs font-semibold tracking-widest uppercase lg:inline-block">
							Lydra AI
						</span>
					</Link>
				</div>
				<div className="flex items-center justify-end">
					<div className="flex flex-grow items-center justify-end space-x-2">
						{isLoggedIn ? (
							<div className="flex items-center gap-2">
								<Button asChild size="sm">
									<Link to="/d">
										Console
										<ArrowRight
											aria-hidden="true"
											className="ml-1.5 h-4 w-4"
											strokeWidth={1.75}
										/>
									</Link>
								</Button>
								<Button asChild size="sm" variant="ghost">
									<Link to="/logout">Logout</Link>
								</Button>
							</div>
						) : (
							<Link to="/login">
								<Button size="sm">
									Login
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										stroke="currentColor"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										className="lucide lucide-arrow-right ml-1 h-4 w-4"
									>
										<path d="M5 12h14"></path>
										<path d="m12 5 7 7-7 7"></path>
									</svg>
								</Button>
							</Link>
						)}
					</div>
				</div>
			</div>
		</header>
	)
}
